module.exports = __webpack_public_path__ + "img/camera-ecobee.fb222290.png";